import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/Automation.css";
import Inboxsettings from "../component/Automation/Inboxsettings";
import Quickflowsforinstagram from "../component/Automation/Quickflowsforinstagram";
import Answerbot from "../component/Automation/Answerbot";
import WhatsAppForms from "../component/Automation/WhatsappForms";
import ChatAssignment from "../component/Automation/ChatAssignment";
import AutoReplies from "../component/Automation/AutoReplies";
import WorkflowPage from "./WorkflowPage";


const Automation = () => {
  const [selectedMenu, setSelectedMenu] = useState("inbox-settings");

  return (
    <div className="container-fluid p-0">

      <div className="d-flex ">
        <div className="bg-light p-1 rounded shadow nav-automation col-md-4" style={{ maxHeight: "100vh" }}>
          <p className="small" style={{ color: "grey" }}>Automation</p>
          <ul className="list-unstyled">
            <li
              className={`p-2 automation-nav ${selectedMenu === "inbox-settings" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("inbox-settings")}
            >
              <i className="icon bi bi-inbox me-2"></i>
              Inbox Settings
            </li>
            <li
              className={`p-2 automation-nav ${selectedMenu === "autoReplies" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("autoReplies")}
            >
              <i className="icon bi bi-reply-fill me-2"></i>
              Custom Auto Reply
            </li>
            <li
              className={`p-2 automation-nav ${selectedMenu === "workFlowList" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("workFlowList")}
            >
              <i className="icon bi bi-stack-overflow me-2"></i>
              Workflows
            </li>

            <li
              className={`p-2 automation-nav ${selectedMenu === "ChatAssigment-panel" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("ChatAssigment-panel")}
            >
              <i className="icon bi bi-chat-left-text-fill me-2"></i>
              Chat Assignment
            </li>

            <li
              className={`p-2 automation-nav ${selectedMenu === "Answerbot-panel" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("Answerbot-panel")}
            >
              <i className="icon bi bi-robot me-2"></i>
              Answer Bot
            </li>

            <li
              className={`p-2 automation-nav ${selectedMenu === "Quick-flow-insta" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("Quick-flow-insta")}
            >
              <i className="icon bi bi-instagram me-2"></i>
              Quick Flows for Instagram
            </li>

            <li
              className={`p-2 automation-nav ${selectedMenu === "WhatsaappForms" ? "selected" : ""}`}
              onClick={() => setSelectedMenu("WhatsappForms")}
            >
              <i className="icon bi bi-whatsapp me-2"></i>
              WHatsApp Forms
            </li>

          </ul>
        </div>

        {/* Main Content */}
        <div className="p-3 flex-grow-1 automation-body col-md-8">
          {selectedMenu === "inbox-settings" && <Inboxsettings />}

          {selectedMenu === "Quick-flow-insta" && <Quickflowsforinstagram />}
          {selectedMenu === "Answerbot-panel" && <Answerbot />}
          {selectedMenu === "WhatsappForms" && <WhatsAppForms />}
          {selectedMenu === "ChatAssigment-panel" && <ChatAssignment />}
          {selectedMenu === "autoReplies" && <AutoReplies />}
          {selectedMenu === "workFlowList" && <WorkflowPage />}
         
        </div>
      </div>
    </div>
  );
};

export default Automation;
